"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Subpages = function Subpages(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 315.944 315.943'
  }, props), /*#__PURE__*/_react["default"].createElement('g', null, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M198.587,206.706c0.231,0.031,0.464,0.047,0.696,0.047c0.774,0,1.539-0.168,2.246-0.49l111.254-50.746\r c2.305-1.047,3.564-3.552,3.043-6.033c-0.527-2.473-2.7-4.253-5.231-4.282c-0.907-0.011-90.988-1.928-130.961-81.815\r c-3.775-7.539-13.067-12.042-21.097-10.115L65.675,75.646c-4.482,1.081-8.052,3.937-9.79,7.831\r c-1.701,3.807-1.463,8.234,0.648,12.149C72.663,125.579,118.8,196.349,198.587,206.706z M65.739,87.882\r c0.364-0.81,1.26-1.448,2.463-1.732l92.865-22.373c0.459-0.113,0.949-0.169,1.45-0.169c2.984,0,6.117,1.943,7.456,4.617\r c30.987,61.923,89.817,80.18,120.604,85.554l-92.121,42.021c-73.915-10.421-117.192-76.998-132.43-105.29\r C65.67,89.831,65.325,88.821,65.739,87.882z'
  }), /*#__PURE__*/_react["default"].createElement('rect', {
    y: '251.726',
    width: '196.331',
    height: '11.385'
  }), /*#__PURE__*/_react["default"].createElement('polygon', {
    points: '310.542,212.739 310.542,201.358 199.262,251.726 199.262,263.116 \t\t'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M310.542,197.383h-28.931l-83.014,39.624l-3.618,0.016c-50.195,0-90.624-8.88-120.849-19.311L0,247.586h196.673\r L310.542,197.383z'
  }), /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M21.146,181.398c21.574,13.632,81.923,45.331,176.217,44.788l109.877-52.445c0,0-5.922,0.032-15.625-0.253l-93.894,42.831\r l-1.534-0.2c-53.687-6.972-92.027-41.212-116.105-71.542l-57.997,26.259C16.654,173.299,16.103,178.214,21.146,181.398z'
  })));
};
/* eslint-enable */
var _default = Subpages;
exports["default"] = _default;